export enum FilterCategory {
  DESTINATION = "DESTINATION",
  STATUS = "STATUS",
}
